document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.getElementById("pricingv2__toggle-switch");
  const cards = document.querySelectorAll(".pricingv2__card");

  const animatePrice = (element, start, end, duration = 400) => {
    const startTime = performance.now();

    const step = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const value = start + (end - start) * progress;
      element.textContent = `$${value.toFixed(2)}`;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };

  const updateCard = (card) => {
    const input = card.querySelector(".pricingv2__card-user input");
    const priceEl = card.querySelector(".pricingv2__card-price-value");
    const freqEl = card.querySelector(".pricingv2__card-price-frequency");

    if (!input || !priceEl || !freqEl) return;

    let userCount = parseInt(input.value, 10);
    if (isNaN(userCount) || userCount < 1) userCount = 1;

    const isYearly = toggle.checked;
    const monthly = parseFloat(priceEl.dataset.monthly);
    const yearly = parseFloat(priceEl.dataset.yearly);
    const base = isYearly ? yearly : monthly;
    const total = base * userCount;

    // Reset frequency label and handle discount
    if (userCount >= 20) {
      priceEl.innerHTML = `<span style="font-size: 20px;">Volume Discount Available</span>`;
      freqEl.style.display = "none";
    } else {
      const currentPrice =
        parseFloat(priceEl.textContent.replace(/[^0-9.]/g, "")) || 0;

      animatePrice(priceEl, currentPrice, total, 400);
      freqEl.textContent = isYearly ? "/month" : "/month"; // Fixed frequency label
      freqEl.style.display = "inline-block";
    }
  };

  // Initialize all cards
  cards.forEach((card) => {
    const input = card.querySelector(".pricingv2__card-user input");

    if (input) {
      input.addEventListener("input", () => updateCard(card));
    }

    updateCard(card);
  });

  // Toggle event
  toggle.addEventListener("change", () => {
    cards.forEach((card) => {
      updateCard(card);
    });
  });
});
